module.exports = __webpack_public_path__ + "img/commissionAgent.c57876fd.svg";